import { render } from "./reservation.vue?vue&type=template&id=0660ae24&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"

import "./reservation.vue?vue&type=style&index=0&id=0660ae24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0660ae24"]])

export default __exports__